import { z } from 'zod'
import { appConfig } from '@/config/app.ts'
import { dailyCutSchema } from '@/modules/allies/dailyCut/types/DailyCut.ts'

export type NewDailyCutData = z.infer<typeof dailyCutSchema>

export interface DailyCutState {
  isLoading: boolean
  filters: string
  selectedAllyId: string
}

export const initialState: DailyCutState = {
  isLoading: false,
  filters: `?limit=${appConfig.pagination.defaultValue}`,
  selectedAllyId: ''
}
